import styled from "@emotion/styled";

import { fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { Loading } from "scmp-app/components/common/loading";
import { ContentItemSearch } from "scmp-app/components/content/content-item-render/variants/search";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NoResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-block: 16px;
`;

export const NoResultsHeader = styled.p`
  margin-block: 0 16px;
  margin-inline: 0;

  color: #000000;
  font-weight: 900;
  font-size: 24px;
  font-family: ${fontRoboto};
  line-height: 28px;

  ${theme.breakpoints.up("desktop")} {
    margin-block: 0 12px;
    margin-inline: 0;

    font-weight: 900;
    font-size: 28px;
    font-family: ${fontRoboto};
    line-height: 33px;
  }
`;

export const NoResultsContent = styled.p`
  color: #000000;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 19px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  padding-block-start: 8px;
`;

export const TitleRow = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h2`
  margin: 0;

  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    font-size: 20px;
  }
`;

export const CountRow = styled.div`
  display: flex;
  gap: 10px;
  justify-content: space-between;
  align-items: center;

  padding-block-end: 8px;

  border-block-end: 1px solid #dfdfdf;
`;

export const ResultCount = styled.div`
  display: flex;
  gap: 6px;
  align-items: baseline;

  color: #727272;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;

export const Count = styled.span`
  font-weight: 700;
`;

export const SortBy = styled.div`
  color: #727272;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  white-space: nowrap;
`;

export const SortByValue = styled.span`
  font-weight: 700;
`;

export const StyledLoading = styled(Loading)`
  margin-block: 40px;
`;

export const ItemContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Item = styled(ContentItemSearch)`
  :first-of-type {
    margin-block-start: 16px;

    ${theme.breakpoints.up("tablet")} {
      margin-block-start: 20px;
    }
  }

  :not(:first-of-type) {
    margin-block-start: 16px;
    padding-block-start: 16px;
    border-block-start: 1px solid #dfdfdf;

    ${theme.breakpoints.up("tablet")} {
      margin-block-start: 24px;
      padding-block-start: 24px;
    }
  }
`;
